import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from './store'

// Basic selectors - directly accessing state properties
export const selectAuth = (state: RootState) => state.auth
export const selectAuthToken = (state: RootState) => state.auth.token
export const selectLaravelToken = (state: RootState) => state.auth.laravel_token
export const selectUser = (state: RootState) => state.auth.user
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated
export const selectIsLoading = (state: RootState) => state.auth.isLoading
export const selectIsFetchingUser = (state: RootState) => state.auth.isFetchingUser
export const selectAuthError = (state: RootState) => state.auth.error
export const selectSplashScreenLoading = (state: RootState) => state.auth.splashScreenLoading

// Patient selectors
export const selectPatient = (state: RootState) => state.patient
export const selectCurrentPatient = (state: RootState) => state.patient.currentPatient
export const selectPatientLoading = (state: RootState) => state.patient.loading
export const selectPatientError = (state: RootState) => state.patient.error

// Simple computed selectors without createSelector to avoid type issues
export const selectCurrentToken = (state: RootState) => 
  state.auth.laravel_token || state.auth.token

export const selectHasValidToken = (state: RootState) => 
  !!(state.auth.laravel_token || state.auth.token)

export const selectShouldShowSplashScreen = (state: RootState) => 
  state.auth.splashScreenLoading || (state.auth.isAuthenticated && state.auth.isFetchingUser)

// Properly memoized selector for auth status to avoid infinite re-renders
export const selectAuthStatus = createSelector(
  [
    (state: RootState) => state.auth.isAuthenticated,
    (state: RootState) => state.auth.isLoading,
    (state: RootState) => state.auth.isFetchingUser,
    (state: RootState) => state.auth.user
  ],
  (isAuthenticated, isLoading, isFetchingUser, user) => ({
    isAuthenticated,
    isLoading,
    isFetchingUser,
    hasUser: !!user,
    isReady: isAuthenticated && !isFetchingUser && !!user
  })
)
